module.exports = __webpack_public_path__ + "img/bg-login.f2abae9a.svg";